var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "143px",
    viewBox: "0 0 400 143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "default-banner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "default-banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-link",
    fill: "#FFEEEE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "a",
    points: "0 0 400 0 400 143 0 143"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#F8E6E6",
    points: "0.5 0.5 399.5 0.5 399.5 142.5 0.5 142.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(157.000000, 38.000000)",
    fill: "#80959D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 29.551000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.076,33.627 L49.931,33.627 L49.931,4.076 L4.076,4.076 L4.076,33.627 Z M0,0 L54.007,0 L54.007,37.703 L0,37.703 L0,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "9.171 27.513 15.286 10.19 26.267 22.597 32.608 19.547 32.608 27.513"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.779,
    cy: 14.266,
    r: 4.076
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    opacity: 0.5,
    points: "35.104 7.04 78.637 31.686 62.408 59.234 56.42 56.021 56.807 61.483 64.569 65.615 85.657 29.805 33.215 0.116 17.834 27.276 24.114 26.104"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.5,
    cx: 63.179,
    cy: 37.703,
    r: 4.076
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    opacity: 0.5,
    points: "33.627 25.475 43.817 25.475 41.967 17.323"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.2c937fe5f9df4070f16812cbf9282688.svg";
export { ForwardRef as ReactComponent };